function stableValue(value) {
  if (Array.isArray(value)) return value.map(stableValue);
  if (!value || typeof value !== 'object') return value;
  return Object.keys(value).sort().reduce((result, key) => {
    if (value[key] !== undefined) result[key] = stableValue(value[key]);
    return result;
  }, {});
}

function originalMediaValue(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  try {
    const url = new URL(text, 'https://www.henryw.me');
    return `${url.pathname}${url.search}`;
  } catch {
    return text;
  }
}

function comparableSource(source) {
  return stableValue({
    source_id: source?.source_id || '',
    route: source?.route || '',
    page: source?.page || '',
    title: source?.title || '',
    anchor: source?.anchor || '',
    body: source?.body || '',
    parts: source?.parts || [],
    view_kind: source?.view_kind || '',
    presentations: source?.presentations || [],
    entity: source?.entity || null,
    media: (source?.media || []).map((media) => ({
      src: originalMediaValue(media?.src),
      fullSrc: originalMediaValue(media?.fullSrc),
      alt: media?.alt || '',
    })),
  });
}

function stableHash(value) {
  let h1 = 1779033703;
  let h2 = 3144134277;
  let h3 = 1013904242;
  let h4 = 2773480762;
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    h1 = h2 ^ Math.imul(h1 ^ code, 597399067);
    h2 = h3 ^ Math.imul(h2 ^ code, 2869860233);
    h3 = h4 ^ Math.imul(h3 ^ code, 951274213);
    h4 = h1 ^ Math.imul(h4 ^ code, 2716044179);
  }
  h1 = Math.imul(h3 ^ (h1 >>> 18), 597399067);
  h2 = Math.imul(h4 ^ (h2 >>> 22), 2869860233);
  h3 = Math.imul(h1 ^ (h3 >>> 17), 951274213);
  h4 = Math.imul(h2 ^ (h4 >>> 19), 2716044179);
  const values = [h1 ^ h2 ^ h3 ^ h4, h2 ^ h1, h3 ^ h1, h4 ^ h1];
  return values.map((part) => (part >>> 0).toString(16).padStart(8, '0')).join('');
}

export function sourceFingerprintValue(source) {
  return stableHash(JSON.stringify(comparableSource(source)));
}

export async function sourceFingerprint(source) {
  return sourceFingerprintValue(source);
}

function meaningfulHref(value) {
  try {
    const url = new URL(value, 'https://www.henryw.me');
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return String(value || '');
  }
}

export function semanticDomSignature(root) {
  const parts = [];
  const visit = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = String(node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) parts.push(`#${text}`);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const element = node;
    if (element.matches('script, style, .snapshot-state, .snapshot-live-probe')) return;
    const tag = element.tagName.toLowerCase();
    parts.push(`<${tag}>`);
    for (const attribute of ['alt', 'title', 'aria-label', 'role', 'type']) {
      const value = element.getAttribute(attribute);
      if (value) parts.push(`${attribute}=${value.replace(/\s+/g, ' ').trim()}`);
    }
    if (tag === 'a' && element.getAttribute('href')) {
      parts.push(`href=${meaningfulHref(element.getAttribute('href'))}`);
    }
    for (const child of element.childNodes) visit(child);
    parts.push(`</${tag}>`);
  };
  for (const child of root.childNodes) visit(child);
  return parts.join('|');
}
